export default function openLoginWidget() {
  return new Promise(function (resolve, reject) {
    var _window$lwapi;

    if (typeof window === 'undefined') {
      reject(new Error('its work only in browser'));
    }

    if (!window.lwapi) {
      reject(new Error('Login Widget don`t used'));
    }

    (_window$lwapi = window.lwapi) === null || _window$lwapi === void 0 ? void 0 : _window$lwapi.open(function (data) {
      if (data) {
        resolve(data);
      } else {
        reject(new Error('closed'));
      }
    });
  });
}